import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Assistant from 'components/organisms/Assistants/Assistant/Assistant';

const StyledEntitiesAssistant = styled(Assistant)`
  ${ComponentStyles}
`;

StyledEntitiesAssistant.propTypes = {
  theme: PropTypes.object
};

export default StyledEntitiesAssistant;
